import firstLetterCapital from "../components/firstLetterCapital";

const transactionNameList = (data: any, transaction: any) => {
  const transactionsDetailList = [
    {
      title: "Mobile No.",
      subTitle: "+" + data?.mobileNo,
    },
    {
      title: "Name",
      subTitle: data?.name,
    },
    {
      title: "Product Name",
      subTitle: firstLetterCapital(data?.productId),
    },
    {
      title: "Transaction Type",
      subTitle: data?.txnType,
    },
    {
      title: "Quantity",
      subTitle: data?.quantity + " Gm",
    },
    {
      title: "Transaction Time",
      subTitle:
        transaction?.transactionDate + " " + transaction?.transactionTime,
    },
    {
      title: "Order ID",
      subTitle: data?.orderId,
    },
  ];

  if (data?.redeemStatus != null) {
    transactionsDetailList.push({
      title: "Order Status",
      subTitle: data?.redeemStatus,
    });
  }

  if (data?.bankAccountNumber != null) {
    transactionsDetailList.push({
      title: "BankAccount No",
      subTitle: data?.bankAccountNumber,
    });
  }
  if (data?.txnReferenceNumber != null) {
    transactionsDetailList.push({
      title: "TxnReference No",
      subTitle: data?.txnReferenceNumber,
    });
  }
  if (data?.awbNo != null) {
    transactionsDetailList.push(
      {
        title: "AWBNo No",
        subTitle: data?.awbNo,
      },
      {
        title: "Logistic Name",
        subTitle: data?.logisticName,
      }
    );
  }
  return transactionsDetailList;
};

const MFtransactionNameList = (data: any, transaction: any) => {
  const transactionsDetailList = [
    {
      title: "FOLIO  NO.",
      subTitle: data?.folio_number ?? "Not avaliable",
    },
    {
      title: "Transaction Time",
      subTitle:
        transaction?.transactionDate + " " + transaction?.transactionTime,
    },
  ];

  if (data?.type === "REDEEM_ALL" || data?.type === "REDEMPTION") {
    transactionsDetailList.push(
      {
        title: "Redeem Type",
        subTitle:
          data?.type === "REDEEM_ALL" ? "Redeem All" : "Redeem Partially",
      },
      {
        title: "Redeemed Amount",
        subTitle: data?.reverse_amount
          ? "₹" +  data?.reverse_amount : "Not avaliable",
      },
      {
        title: "Units",
        subTitle: data?.reverse_units ?? "Not avaliable",
      },
      {
        title: "NAV",
        subTitle: data?.price ?? "Not avaliable",
      }
    );
  } else {
    transactionsDetailList.push(
      {
        title: "Invested",
        subTitle: "₹" + data?.amount,
      },
      {
        title: "Units",
        subTitle: data?.reverse_units ?? "Not avaliable",
      },
      {
        title: "NAV",
        subTitle: data?.price ?? "Not avaliable",
      },
      {
        title: "Total Amount",
        subTitle: "₹" + data?.amount,
      }
    );
  }

  return transactionsDetailList;
};

export { transactionNameList, MFtransactionNameList };
